/**
 * @generated SignedSource<<283b774cf112db1beaa343e4dcbb7a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useAdminUserRelayByEmailQuery$variables = {
  email: string;
  systemId: string;
};
export type useAdminUserRelayByEmailQuery$data = {
  readonly listAdminUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly adminSystemRoles: ReadonlyArray<{
          readonly id: string;
          readonly removedOn: any | null | undefined;
          readonly role: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly roleId: string;
        }>;
        readonly email: string;
        readonly id: string;
      };
    }> | null | undefined;
  } | null | undefined;
};
export type useAdminUserRelayByEmailQuery = {
  response: useAdminUserRelayByEmailQuery$data;
  variables: useAdminUserRelayByEmailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "systemId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "eq",
                "variableName": "email"
              }
            ],
            "kind": "ObjectValue",
            "name": "email"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "AdminUserConnection",
    "kind": "LinkedField",
    "name": "listAdminUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUser",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "eq",
                            "variableName": "systemId"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "systemId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "AdminSystemRole",
                "kind": "LinkedField",
                "name": "adminSystemRoles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "removedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminUserRelayByEmailQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminUserRelayByEmailQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "eb8716eb1d2ba21a09eac5680d8f362f",
    "id": null,
    "metadata": {},
    "name": "useAdminUserRelayByEmailQuery",
    "operationKind": "query",
    "text": "query useAdminUserRelayByEmailQuery(\n  $email: String!\n  $systemId: ID!\n) {\n  listAdminUsers(filter: {email: {eq: $email}}, first: 1) {\n    edges {\n      node {\n        id\n        email\n        adminSystemRoles(filter: {systemId: {eq: $systemId}}) {\n          id\n          roleId\n          removedOn\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0644aafc9403e1acffb29e0659748086";

export default node;
